import React, {useState, useMemo, useEffect, useRef, useContext} from 'react';
import styled from 'styled-components';

import theme, {bp, color} from 'settings/theme';

import {SearchContext} from 'services/searchService';


type Props = {};

type StyledProps = {
  isOpen: boolean
};


// Component
const Component: React.FC<Props> = (props) => {

  const node = useRef<HTMLDivElement>(null);
  const search = useContext(SearchContext);

  const [isOpen, setIsOpen] = useState(false);

  const toggleTextOptions = {
    popularity: 'Popularity',
    pricehilo: 'Price',
    pricelohi: 'Price'
  };

  const ToggleIcon = (props) => {

    if(props.name === 'popularity'){
      return <img src="/icons/icon-sort-arrows.svg" className="toggleIcon-flipped" alt="Sorting Arrow" />;
    }
    else if(props.name === 'pricelohi'){
      return <img src="/icons/icon-sort-arrows.svg" alt="Sorting Arrow" />;
    }
    else if(props.name === 'pricehilo'){
      return <img src="/icons/icon-sort-arrows.svg" className="toggleIcon-flipped" alt="Sorting Arrow" />;
    }
    
    return null;

  };

  const toggleText = useMemo(() => toggleTextOptions[search.meta?.sortBy ?? 'popularity'], [search.meta?.sortBy])


  // Handle all clicks to see if the click was outside
  const handleClick = e => {
    if (node?.current?.contains(e.target) === false) {
      setIsOpen(false);
    }
  };

  // React to Clicks
  useEffect(() => {

    // add when mounted
    document.addEventListener("mousedown", handleClick);

    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    }

  }, []);


  const handleToggleClicked = () => {
    setIsOpen(!isOpen);
  }

  const handleSortOptionClicked = (optionName: string) => {
    setIsOpen(false);
    search.setSortBy!(optionName);
    search.doSearch!();
  }

  return (
    <StyledComponent isOpen={isOpen} className="searchSort" ref={node}>

      <button onClick={handleToggleClicked}>
        <div className="searchSort-text">
          {toggleText}
        </div>
        <div className="searchSort-icon">
          {/* <img src="/icons/icon-sort-arrows.svg" /> */}
          <ToggleIcon name={search.meta?.sortBy} />
        </div>
      </button>

      <div className="searchSort-panel">

        <button className="searchSort-option" onClick={() => handleSortOptionClicked('popularity')}>
          <div className="searchSort-option-text">
            Popularity
          </div>
          <div className="searchSort-option-icon">
            <img src="/icons/icon-sort-arrows.svg" className="toggleIcon-flipped" alt="Sorting Arrow" />
          </div>
        </button>

        {search.params?.['availability']?.indexOf('short term hire') === -1 &&
          <>
            <button className="searchSort-option" onClick={() => handleSortOptionClicked('pricelohi')}>
                <div className="searchSort-option-text">
                  Price: Low-High
                </div>
                <div className="searchSort-option-icon">
                  <img src="/icons/icon-sort-arrows.svg" />
                </div>
            </button>
            <button className="searchSort-option" onClick={() => handleSortOptionClicked('pricehilo')}>
              <div className="searchSort-option-text">
                Price: High-Low
              </div>
              <div className="searchSort-option-icon">
                <img src="/icons/icon-sort-arrows.svg" className="toggleIcon-flipped" alt="Sorting Arrow" />
              </div>
            </button>
          </>
        }
          

      </div>

    </StyledComponent>

  );

}


export default Component;




// Styles
const StyledComponent = styled.div<StyledProps>`

  display: flex;
  position: relative;

  button{

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    transition: all 0.15s ease-out;

    &:hover, &:focus{
      background-color: ${color.pageBackground};
    }

  }


  .searchSort-icon{

    margin-left: 8px;

    img{
      position: relative;
      top: 1px;
      width: 14px;
      height: 14px;
    }

    .icon{

      position: relative;
      top: 1px;
      width: 14px;
      height: 14px;

      svg{
          fill: ${color.grey(50)};
      }

    }

  }

  .toggleIcon-flipped{
    transform: rotate(180deg);
  }

  .searchSort-text{
    position: relative;
    top: 1px;
  }


  .searchSort-panel{
    display: ${props => props.isOpen? 'block' : 'none'};
    position: absolute;
    top: 100%;
    right: -1px;
    min-width: calc(100% + 2px);
    border: solid 1px ${color.lines};
    background-color: white;
  }


  .searchSort-option{

    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;

    .searchSort-option-text{
      font-size: 14px;
      white-space: nowrap;
    }

    .searchSort-option-icon{

      margin-left: 14px;

      img{
        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;
      }

      .icon{

        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;

        svg{
          fill: ${color.grey(50)};
        }

      }

    }

  }


  @media (min-width: ${bp(3)}) {

    button{
      padding-left: 24px;
      padding-right: 22px;
    }

    .searchSort-icon{

      margin-left: 12px;

      img{
        top: 1px;
        width: 18px;
        height: 18px;
      }

    }

    .searchSort-text{
      font-size: 16px;
    }


    .searchSort-option{

      height: 50px;

      .searchSort-option-text{
        font-size: 15px;
      }

    }
  
  }


`;



